import { render, staticRenderFns } from "./search.vue?vue&type=template&id=1fb0cab0&lang=pug"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@ui-common/vue-search/dist/vue-search.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@ui-common/vue-search-result/dist/vue-search-result.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@ui-common/vue-pagination/dist/vue-pagination.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "./search.vue?vue&type=style&index=4&id=1fb0cab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports